package com.loyola.acessoescola.ui.registered

import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.add
import acessoescola.composeapp.generated.resources.add_24px
import acessoescola.composeapp.generated.resources.admin_panel_settings_24px
import acessoescola.composeapp.generated.resources.connecting_to_server
import acessoescola.composeapp.generated.resources.new_user_tip_1
import acessoescola.composeapp.generated.resources.new_user_tip_2
import acessoescola.composeapp.generated.resources.privacy_policy
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.BottomAppBar
import androidx.compose.material3.ElevatedSuggestionChip
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.FloatingActionButtonDefaults
import androidx.compose.material3.FloatingActionButtonElevation
import androidx.compose.material3.Icon
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SmallFloatingActionButton
import androidx.compose.material3.SuggestionChip
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.loyola.acessoescola.services.quintadb.ErrorMessages
import com.loyola.acessoescola.ui.components.ErrorDialog
import com.loyola.acessoescola.ui.components.Loading
import com.loyola.acessoescola.ui.theme.AcessoEscolaTheme
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource


@Composable
fun RegisteredScreen(
    registeredViewModel: RegisteredViewModel,
    navToHintScreen: () -> Unit,
    paddingValues: PaddingValues,
    navToEditRecord: (String) -> Unit,
    navToPolicy: () -> Unit
) {
    val records by registeredViewModel.records.collectAsState()
    var errorMessage by remember { mutableStateOf("") }
    val uiState by registeredViewModel.uiState.collectAsState()

    registeredViewModel.updateRecordList { errorMessage = it ?: ErrorMessages.UNKNOWN.message }

    if (errorMessage != "") {
        ErrorDialog(
            errorMessage = errorMessage,
            onErrorMessageChange = { errorMessage = it }
        )
    }

    Scaffold(
        bottomBar = {
            BottomAppBar(
                actions = {
                    ElevatedSuggestionChip(
                        onClick = { navToPolicy() },
                        label = { Text(text = "Politica de Privacidade") },
                        modifier = Modifier.padding(start = 16.dp),
                        icon = {
                            Icon(
                                imageVector = vectorResource(Res.drawable.admin_panel_settings_24px),
                                contentDescription = stringResource(Res.string.privacy_policy)
                            )
                        }
                    )
                },
                floatingActionButton = {
                    FloatingActionButton(
                        onClick = { navToHintScreen() }
                    ) {
                        Icon(
                            imageVector = vectorResource(Res.drawable.add_24px),
                            contentDescription = stringResource(Res.string.add)
                        )
                    }
                }
            )
        },
        modifier = Modifier.padding(top=paddingValues.calculateTopPadding())
    ) { paddingValues ->
        if (uiState.isLoading){
            Box(
                contentAlignment = Alignment.Center,
                modifier = Modifier.fillMaxSize()
            ) {
                Loading(
                    message = stringResource(Res.string.connecting_to_server),
                    modifier = Modifier.fillMaxWidth(0.8f).fillMaxHeight(0.4f)
                )
            }
        }else if (records.isEmpty()) {
            FirstAuthorizerTip(navToHintScreen)
        } else {
            AuthorizerList(
                paddingValues = paddingValues,
                records = records.map { it.toRegisteredRecord() },
                deleteRecord = { recordID ->
                    registeredViewModel.deleteRecord(recordID) {
                        errorMessage = it ?: ErrorMessages.UNKNOWN.message
                    }
                },
                navToEditRecord = { recordID ->
                    navToEditRecord(recordID)
                }
            )
        }
    }

}

@Composable
private fun FirstAuthorizerTip(
    navToHintScreen: () -> Unit,
) {
    Column {
        Spacer(modifier = Modifier.weight(1f))
        FlowRow(
            verticalArrangement = Arrangement.Center,
            horizontalArrangement = Arrangement.Center,
            itemVerticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth()
        ) {
            Text(
                text = stringResource(Res.string.new_user_tip_1),
                textAlign = TextAlign.Center,
            )
            SmallFloatingActionButton(
                elevation = FloatingActionButtonDefaults.elevation(
                    defaultElevation = 0.dp,
                    pressedElevation = 0.dp,
                    focusedElevation = 0.dp,
                    hoveredElevation = 0.dp
                ),
                onClick = { navToHintScreen() },
            ) {
                Icon(
                    imageVector = vectorResource(Res.drawable.add_24px),
                    contentDescription = stringResource(Res.string.add)
                )
            }
            Text(
                text = stringResource(Res.string.new_user_tip_2),
                textAlign = TextAlign.Center,
            )
        }
        Spacer(modifier = Modifier.weight(1f))
    }
}

@Preview
@Composable
private fun FirstAuthorizerTipPreview() {
    AcessoEscolaTheme {
        FirstAuthorizerTip({})
    }
}

@Composable
private fun AuthorizerList(
    paddingValues: PaddingValues,
    records: List<RegisteredRecord>,
    deleteRecord: (String) -> Unit,
    navToEditRecord: (String) -> Unit
) {
    LazyColumn(
        modifier = Modifier.padding(paddingValues).padding(horizontal = 8.dp),
    ) {
        items(records) { record ->
            Authorizer(
                imageUrl = record.imageUrl,
                deleteRecord = { deleteRecord(record.recordID) },
                fullName = record.fullName,
                navToEditRecord = { navToEditRecord(record.recordID) },
                bound = record.bound
            )
        }
    }
}

@Composable
expect fun Authorizer(
    imageUrl: String,
    deleteRecord: () -> Unit,
    fullName: String,
    navToEditRecord: () -> Unit,
    bound: String
)

